import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ConfigurableQuestionnairesApi } from '../../infrastructure';
import * as QuestionnaireGroupsActions from '../actions/questionnaire-groups.actions';

/**
 * Questionnaire groups effects
 */
@Injectable({
    providedIn: 'root',
})
export class QuestionnaireGroupsEffects {
    /**
     * Load questionnaire groups effect
     */
    loadQuestionnaireGroups$ = createEffect(() =>
        this.actions$.pipe(
            ofType(QuestionnaireGroupsActions.loadQuestionnaireGroups),
            switchMap(() =>
                this.api.loadQuestionnaireGroups().pipe(
                    map(questionnaireGroups =>
                        QuestionnaireGroupsActions.loadQuestionnaireGroupsSuccess({ questionnaireGroups }),
                    ),
                    catchError((error: unknown) =>
                        of(QuestionnaireGroupsActions.loadQuestionnaireGroupsFailure({ error })),
                    ),
                ),
            ),
        ),
    );

    /**
     * Constructor
     * @param actions$ Actions
     * @param api ConfigurableQuestionnairesApi
     */
    constructor(
        private actions$: Actions,
        private api: ConfigurableQuestionnairesApi,
    ) {}
}
